<template>
    <div class="modal-card" ref="element">
        <header class="modal-card-head">
            <p class="modal-card-title">{{ editEnabled ? "Edit Answer" : "Add Answer" }}</p>
        </header>
        <section class="modal-card-body">
            <b-field label="Answer Text:">
                <b-input type="text" v-model="aText" placeholder="Answer Text"
                    :disabled="role === 'viewer'"></b-input>
            </b-field>
            <b-field v-if="bAnswerError" style="color: red">
                Please enter answer text.
            </b-field>
            <b-field label="Answer Text (Albanian):">
                <b-input type="text" v-model="aTextAl" placeholder="Answer Text (Albanian)"
                    :disabled="role === 'viewer'"></b-input>
            </b-field>
            <b-field v-if="bAnswerAlError" style="color: red">
                Please enter answer text in Albanian.
            </b-field>
        </section>
        <footer class="modal-card-foot">
            <b-button type="is-info" @click="saveAnswer" v-if="editEnabled"
                :disabled="role === 'viewer'">Submit</b-button>
            <b-button type="is-info" icon-left="plus" @click="addAnswer" v-else :disabled="role === 'viewer'">Add
                new
                answer</b-button>
            <b-button type="is-light" @click="closeModal()">Cancel</b-button>
        </footer>
    </div>
</template>

<script>

export default {
  name: 'AnswerAddEdit',
  props: ['editEnabled', 'propAnswer', 'propId', 'propParentFn', 'questionnaireId', 'questionId'],
  data: () => {
    return {
      editStaticAnswerRef: {},
      aText: '',
      aTextAl: '',
      options: [],
      answerId: '',
      tableData: [],
      bAnswerError: false,
      bAnswerAlError: false
    }
  },
  computed: {
    workspaceId () {
      return this.$store.state.workspaceId
    },
    role () {
      return this.$store.state.role
    },
    userId () {
      return this.$store.state.uid
    }
  },
  mounted: function () {
    if (this.editEnabled) {
      this.answerId = this.propId
      this.editStaticAnswerRef = this.propAnswer
      this.aText = this.editStaticAnswerRef.text
      this.aTextAl = this.editStaticAnswerRef.textAl
    }
  },
  methods: {
    addAnswer () {
      if (this.role !== 'viewer') {
        this.bAnswerError = false
        this.bAnswerAlError = false
        if (this.aText === '') {
          this.bAnswerError = true
        } else if (this.aTextAl === '') {
          this.bAnswerAlError = true
        } else {
          let newAnswerRef = null
          if (!this.getNotMigrated().includes(this.userId)) {
            newAnswerRef = this.$store.state.database.ref('/neoslide/questionnaires/' + this.workspaceId + '/' + this.questionnaireId + '/' + this.questionId + '/options').push()
          } else {
            newAnswerRef = this.$store.state.database.ref('/questionnaires/' + this.userId + '/' + this.questionnaireId + '/' + this.questionId + '/options').push()
          }
          let answerId = newAnswerRef.key
          let answer = {
            text: this.aText,
            textAl: this.aTextAl,
            id: answerId
          }
          this.propParentFn(answer)
          this.$parent.close()
        }
      }
    },
    saveAnswer () {
      if (this.role !== 'viewer') {
        this.bAnswerError = false
        this.bAnswerAlError = false
        if (this.aText === '') {
          this.bAnswerError = true
        } else if (this.aTextAl === '') {
          this.bAnswerAlError = true
        } else {
          let updatedAnswer = {
            text: this.aText,
            textAl: this.aTextAl,
            id: this.propAnswer.id
          }
          this.propParentFn(updatedAnswer, this.answerId)
          this.closeModal()
        }
      }
    },
    cancelEdit () {
      if (this.editEnabled) {
        this.aText = this.editStaticAnswerRef.text
        this.aTextAl = this.editStaticAnswerRef.textAl
      }
      this.closeModal()
    },
    closeModal () {
      this.$parent.close()
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/questionnaires/AnswerAddEdit.vue